module.exports = __webpack_public_path__ + "static/media/specular-social-card.94154227.png";